<template>
    <div class="artical-box">
        <ChildBanner :childbannerData='childbannerData' ref='childBaner'></ChildBanner>
        <Articles></Articles>
        <FromBanner :msg='msg'></FromBanner>
    </div>
</template>
<script>
    import ChildBanner from '@/components/base/childbanner'//引入子页面的banner
    import Articles from '@/components/base/childbanner'    
    import FromBanner from '@/components/main/school/articles'//引入文章页面  
    export default {
        name: 'Artical',
        data() {
            return {
                childbannerData: {
                    childbanner: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/%E7%BB%84%20750.jpg',
                    caption: 'marketing college',
                    title: '蓝鲸营销学院'
                },
                msg: {
                    caption: '诊断您的网站SEO布局和关键词布局定制海外营销计划',
                    botton: '联系我们',
                }
            }
        },
        components: {
            ChildBanner,
            Articles,
            FromBanner
        },
        methods: {
            childMethods() {
                this.$refs.childBaner.changeShow()
            }
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/main/artical.vue